import { render, staticRenderFns } from "./BlockedResources.vue?vue&type=template&id=6beb8471&scoped=true"
import script from "./BlockedResources.vue?vue&type=script&lang=js"
export * from "./BlockedResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beb8471",
  null
  
)

export default component.exports